var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"common-card-row"},[_c('v-col',{staticClass:"common-card-col",attrs:{"cols":"12"}},[_c('AlertsTemplate',{attrs:{"page_content":_vm.page_content,"isPowerdata":_vm.isPowerdata}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }